import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { map } from 'rxjs/operators';
import { UtilitiesService } from 'src/app/core/utilities.service';
import { StoreService } from 'src/app/store.service';

@Component({
  selector: 'app-domain-list',
  templateUrl: './domain-list.component.html',
  styleUrls: ['./domain-list.component.scss'],
})
export class DomainListComponent implements OnInit {
  @ViewChild('guideModal001') guideModal001: TemplateRef<any>;
  @ViewChild('guideModal002') guideModal002: TemplateRef<any>;
  @ViewChild('detailsModal') detailsModal: TemplateRef<any>;
  @ViewChild('subdomainModal') subdomainModal: TemplateRef<any>;
  @ViewChild('manageSubdomainsModal') manageSubdomainsModal: TemplateRef<any>;

  bearer;
  store_id;
  domainList = [];
  selectedDomain: any = {
    cnameName: '',
    cnameValue: '',
  };

  isLoading;

  finalStep = 23;

  constructor(
    private svc: StoreService,
    private modalService: NgbModal,
    private utils: UtilitiesService
  ) {}

  testClose() {
    // this.utils.msgBox.open({
    //   message: 'Discard mixture name change?',
    //   title: 'Discard?',
    //   icon: 'warning',
    //   buttonList: [
    //     {
    //       text: 'No',
    //     },
    //     {
    //       text: 'Discard',
    //       style: 'warning',
    //       onClick: () => {console.log('xxxxxxxxxxx')},
    //     },
    //   ],
    // });
  }

  ngOnInit(): void {
    this.refreshList();
  }

  refreshList() {
    this.bearer = localStorage.getItem('bearer');
    this.store_id = localStorage.getItem('store_id');

    this.isLoading = true;
    this.svc.getDomainList(this.bearer, this.store_id).subscribe(
      (res) => {
        this.domainList = res['data'];
        this.isLoading = false;
      },
      (error) => {},
      () => {
        this.isLoading = false;
      }
    );
  }

  displayStatus(status) {
    switch (+status) {
      case 0:
        return 'Disabled';
        break;
      case 1:
        return 'Deploying';
        break;
      case 2:
        return 'Active';
        break;
      case 3:
        return 'Failed';
        break;
      case 8:
        return 'Deleting';
        break;
      case 9:
        return 'Deleted';
        break;

      default:
        return `Unknown code (${status})`;
        break;
    }
  }

  openSubdomainPrompt(domainData) {
    this.selectedDomain = domainData;
    this.userSubdomain = '';

    this.subdomainModalRef = this.modalService.open(this.subdomainModal, {
      size: 'md',
      backdrop: 'static',
    });
  }

  proceedVerifySubdomain() {
    const sub = (this.userSubdomain || '').trim();
    if (!sub) {
      this.utils.msgBox.open({
        message: this.utils.translate('Please enter a subdomain before continuing.'),
        title: this.utils.translate('Subdomain required'),
        icon: 'warning',
      });
      return;
    }

    const params = {
      store_domain_id: this.selectedDomain.store_domain_id,
      storeId: this.selectedDomain.store_id,
      subdomain: sub,
    };

    const token = localStorage.getItem('bearer');
    this.isVerifying = true;
    this.svc
      .requestVerifyDomain(token, params)
      .pipe(
        map((res) => {
          this.isVerifying = false;
          console.info({ res });
          // Handle API-declared error responses (e.g. status: 'error')
          if (res && res['status'] === 'error') {
            const msg = this.extractApiErrorMessage(res);
            this.utils.notify.showError(msg);
            return;
          }
          if (res && res['status'] == 'success' && res['data']) {
            const data = res['data'];
            const check = data && data['check'];

            if (check && check['found'] === false) {
              const name = check['name'];
              const target = check['target'];
              this.utils.msgBox.open({
                message: this.utils.translate(
                  `<p><b>We couldn't verify your domain yet.</b></p>
                  <p>Please add the following CNAME record at your domain provider (DNS settings):</p>
                  <ul>
                    <li><b>Host / Name:</b> <span style="font-size: small">{0}</span></li>
                    <li><b>Points to / Value:</b> <span style="font-size: small">{1}</span></li>
                  </ul>
                  <p style="margin-top:8px;">After saving, it may take some time to update across the internet (up to 24–48 hours). Then click <b>Try again</b>.</p>`,
                  [name, target]
                ),
                title: this.utils.translate('CNAME record not found'),
                icon: 'warning',
              });
              return;
            }

            if (check && check['found'] === true) {
              // Optimistic local update so the Manage Subdomain modal reflects the new entry immediately
              try {
                const list = this.getSubdomainList(this.selectedDomain);
                if (!list.includes(sub)) {
                  list.push(sub);
                  this.selectedDomain.subdomains = JSON.stringify(list);
                }
              } catch {}

              setTimeout(() => {
                this.refreshList();
                this.subdomainModalRef?.close();
                this.subdomainModalRef = null;
              }, 0);

              setTimeout(() => {
                // For add subdomain flow, show a simple toast instead of domain verified modal
                const sub = (this.userSubdomain || '').trim();
                const msg = sub
                  ? this.utils.translate("Subdomain '{0}' added successfully.", [sub])
                  : this.utils.translate('Subdomain added successfully.');
                this.utils.notify.showInfo(msg);
              }, 100);

              return;
            }

            setTimeout(() => {
              this.refreshList();
              this.subdomainModalRef?.close();
              this.subdomainModalRef = null;
            }, 0);
          } else {
            console.error({ res });
            if (res && res['status'] === 'error') {
              const msg = this.extractApiErrorMessage(res);
              this.utils.notify.showError(msg);
            } else {
              // Use toast for generic error to avoid wrong modal during add subdomain flow
              this.utils.notify.showError(
                this.utils.translate('Verification failed. Please try again later.')
              );
            }
          }
        })
      )
      .subscribe(
        (_) => _,
        (error) => {
          this.isVerifying = false;
          console.error('verify_cname error:', error);
          const api = error?.error;
          if (api && api.status === 'error') {
            const msg = this.extractApiErrorMessage(api);
            this.utils.notify.showError(msg);
          } else {
            this.utils.notify.showError(
              this.utils.translate('Something went wrong while verifying your domain. Please try again later.')
            );
          }
        }
      );
  }

  modalRef;
  subdomainModalRef;
  userSubdomain: string = '';
  isVerifying = false;

  openManageSubdomains(domainData) {
    this.selectedDomain = domainData;
    this.modalRef = this.modalService.open(this.manageSubdomainsModal, {
      size: 'lg',
      backdrop: 'static',
    });
  }

  deleteSubdomain(sub: string) {
    if (!sub) return;
    const domainId = this.selectedDomain?.store_domain_id;
    const storeId = this.selectedDomain?.store_id || localStorage.getItem('store_id');
    if (!domainId) {
      this.utils.notify.showError(this.utils.translate('Domain ID not found.'));
      return;
    }

    this.utils.msgBox.open({
      message: this.utils.translate(
        "Delete subdomain '{0}'? This action cannot be undone.",
        [sub]
      ),
      title: this.utils.translate('Confirm delete subdomain?'),
      icon: 'warning',
      buttonList: [
        { text: this.utils.translate('Cancel') },
        {
          text: this.utils.translate('Yes, delete!'),
          style: 'danger',
          onClick: () => {
            const token = localStorage.getItem('bearer');
            this.svc.deleteSubdomain(token, {
              store_id: storeId,
              store_domain_id: domainId,
              subdomain: sub,
            }).subscribe(
              (res) => {
                if (res && res['status'] === 'success') {
                  this.utils.notify.showInfo(
                    this.utils.translate("Deleted subdomain '{0}'.", [sub])
                  );
                  // Optimistic local update
                  try {
                    const list = this.getSubdomainList(this.selectedDomain);
                    const updated = list.filter((s) => s !== sub);
                    this.selectedDomain.subdomains = JSON.stringify(updated);
                  } catch {}
                  // Refresh list to sync
                  this.refreshList();
                } else if (res && res['status'] === 'error') {
                  const msg = this.extractApiErrorMessage(res);
                  this.utils.notify.showError(msg);
                } else {
                  this.utils.notify.showError(
                    this.utils.translate('Failed to delete subdomain.')
                  );
                }
              },
              (error) => {
                console.error('delete_subdomain error:', error);
                const api = error?.error;
                if (api && api.status === 'error') {
                  const msg = this.extractApiErrorMessage(api);
                  this.utils.notify.showError(msg);
                } else {
                  this.utils.notify.showError(
                    this.utils.translate('Something went wrong...')
                  );
                }
              }
            );
          },
        },
      ],
    });
  }

  splitCnameDetails(domainData) {
    let resourceRecord = domainData['resource_record'] ?? '{}';
    resourceRecord = JSON.parse(resourceRecord);

    if (!resourceRecord.Name) {
      this.selectedDomain['cnameName'] = null;
      this.selectedDomain['cnameValue'] = resourceRecord.Value ?? null;
      this.selectedDomain['cnameDomainName'] = null;
      return;
    }

    let cnameNameSegments = resourceRecord.Name.split('.');
    let cnameName = cnameNameSegments.shift();
    let cnameDomainName = cnameNameSegments.join('.');
    cnameDomainName = cnameDomainName.substr(0, cnameDomainName.length - 1);

    this.selectedDomain['cnameName'] = cnameName;
    this.selectedDomain['cnameValue'] = resourceRecord.Value;
    this.selectedDomain['cnameDomainName'] = cnameDomainName;
  }

  showUserInput(domainData) {
    this.selectedDomain = domainData;

    if (+domainData.setup_progress === 11) {
      if (typeof domainData['resource_record'] !== 'undefined') {
        this.splitCnameDetails(domainData);

        this.modalRef = this.modalService.open(this.guideModal001, {
          size: 'lg',
          backdrop: 'static',
        });

        this.modalRef.result
          .then((result) => {
            console.log(result);
            if (result !== false) {
            }
          })
          .catch((error) => {
            console.log(error);
          });
      } else {
        console.error('Resource Record cannot be found!');
      }
    } else if (+domainData.setup_progress === 21) {
      this.modalRef = this.modalService.open(this.guideModal002, {
        size: 'lg',
        backdrop: 'static',
      });

      this.modalRef.result
        .then((result) => {
          console.log(result);
          if (result !== false) {
          }
        })
        .catch((error) => {
          console.log(error);
        });
    }
  }

  cnameSubmitted(selectedDomain) {
    const params = {
      store_domain_id: selectedDomain.store_domain_id,
      storeId: selectedDomain.store_id,
    };

    const token = localStorage.getItem('bearer');
    this.svc
      .requestVerifyDomain(token, params)
      .pipe(
        map((res) => {
          console.info({ res });
          if (res && res['status'] == 'success' && res['data']) {
            const data = res['data'];
            const check = data && data['check'];

            // If API says success but CNAME check not found, show helpful message and keep modal open
            if (check && check['found'] === false) {
              const name = check['name'];
              const target = check['target'];
              this.utils.msgBox.open({
                message: this.utils.translate(
                  `<p><b>We couldn't verify your domain yet.</b></p>
                  <p>Please add the following CNAME record at your domain provider (DNS settings):</p>
                  <ul>
                    <li><b>Host / Name:</b> <span style="font-size: small">{0}</span></li>
                    <li><b>Points to / Value:</b> <span style="font-size: small">{1}</span></li>
                  </ul>
                  <p style="margin-top:8px;">After saving, it may take some time to update across the internet (up to 24–48 hours). Then click <b>Try again</b>.</p>`,
                  [name, target]
                ),
                title: this.utils.translate('CNAME record not found'),
                icon: 'warning',
              });
              return;
            }

            // If found true, confirm success to user, then refresh and close
            if (check && check['found'] === true) {
              setTimeout(() => {
                this.refreshList();
                this.modalService.dismissAll();
              }, 0);

              setTimeout(() => {
                const name = check['name'];
                const target = check['target'];
                this.utils.msgBox.open({
                  message: this.utils.translate(
                    `<b>All set!</b> We found your CNAME record and linked it successfully.
                    It may take a few minutes for changes to reflect across the dashboard.`,
                    [name, target]
                  ),
                  title: this.utils.translate('Domain verified'),
                  icon: 'success',
                });
              }, 100);

              return;
            }

            debugger;

            // Otherwise refresh and close modal
            setTimeout(() => {
              this.refreshList();
              this.modalService.dismissAll();
            }, 0);
          } else {
            console.error({ res });
            if (res && res['status'] === 'error') {
              const msg = this.extractApiErrorMessage(res);
              this.utils.notify.showError(msg);
            } else {
              this.utils.msgBox.open({
                message: this.utils.translate(
                  'Verification failed. Please try again later.'
                ),
                title: this.utils.translate('Verification failed'),
                icon: 'error',
              });
            }
          }
        })
      )
      .subscribe(
        (_) => _,
        (error) => {
          console.error('verify_cname error:', error);
          const api = error?.error;
          if (api && api.status === 'error') {
            const msg = this.extractApiErrorMessage(api);
            this.utils.notify.showError(msg);
          } else {
            this.utils.notify.showError(
              this.utils.translate(
                'Something went wrong while verifying your domain. Please try again later.'
              )
            );
          }
          // Keep the modal open so user can retry
        }
      );
  }

  deleteLoadingList = [];

  isDeleting(domainData) {
    return (
      this.deleteLoadingList.includes(domainData?.store_domain_id) ||
      +domainData.status === 8
    );
  }

  deleteDomain(domainData) {
    this.utils.msgBox.open({
      message: this.utils.translate(
        'Delete this domain? This process cannot be undone.'
      ),
      title: this.utils.translate('Confirm delete domain?'),
      icon: 'warning',
      buttonList: [
        {
          text: this.utils.translate('Cancel'),
        },
        {
          text: this.utils.translate('Yes, delete!'),
          style: 'danger',
          onClick: () => {
            console.log({ domainData });

            const { store_domain_id, domain_name } = domainData;
            this.deleteLoadingList.push(store_domain_id);
            this.svc.deleteDomain({ store_domain_id }).subscribe(
              (res) => {
                this.utils.notify.showInfo(
                  this.utils.translate("Deleting domain '{0}'...", [
                    domain_name,
                  ])
                );

                const targetDomain = this.domainList.find(
                  (item) => +item.store_domain_id === +store_domain_id
                );
                targetDomain.status = 8;
              },
              (error) => {
                console.log('>> ERROR:', error);
                this.utils.notify.showError(
                  this.utils.translate('Something went wrong...')
                );
                this.deleteLoadingList = this.deleteLoadingList.filter(
                  (item) => item != store_domain_id
                );
              },
              () => {
                // Remove from loading
                this.deleteLoadingList = this.deleteLoadingList.filter(
                  (item) => item != store_domain_id
                );
              }
            );
          },
        },
      ],
    });
  }

  showDetails(domainData) {
    this.selectedDomain = domainData;

    this.splitCnameDetails(domainData);

    this.modalRef = this.modalService.open(this.detailsModal, {
      size: 'lg',
      backdrop: 'static',
    });

    this.modalRef.result
      .then((result) => {
        console.log(result);
        if (result !== false) {
        }
      })
      .catch((error) => {
        console.log(error);
      });
  }

  getPercentage(currentValue, totalValue): string {
    return Math.ceil((+currentValue / +totalValue) * 100) + '%';
  }

  closeModal(e?) {
    this.modalRef.close(true);
  }

  closeSubdomainModal() {
    this.subdomainModalRef?.close();
    this.subdomainModalRef = null;
  }

  selectAll(event) {
    event.target.select();
  }

  getSubdomainList(domainData: any): string[] {
    const raw = domainData?.subdomains;
    if (!raw) return [];
    if (Array.isArray(raw)) {
      return raw.filter((s) => !!(s && String(s).trim())).map((s) => String(s).trim());
    }
    try {
      const parsed = JSON.parse(String(raw));
      if (Array.isArray(parsed)) {
        return parsed.map((s) => (s == null ? '' : String(s).trim())).filter((s) => !!s);
      }
      return [];
    } catch (e) {
      // If JSON parsing fails, treat as empty
      return [];
    }
  }

  isClickableSubdomain(sub: string): boolean {
    // Wildcards and special DNS symbols are not directly visitable
    return sub !== '*' && sub !== '@' && sub !== '' && sub != null;
  }

  buildSubdomainUrl(sub: string, domain: string): string {
    if (!sub || sub === '@') {
      return `https://${domain}`;
    }
    if (sub === '*') {
      // Fallback to main domain; wildcard not directly navigable
      return `https://${domain}`;
    }
    return `https://${sub}.${domain}`;
  }

  /**
   * Extracts a user-friendly error message from API responses that follow
   * the shape shown by the backend, e.g.:
   * { status: 'error', status_code: 400, message: 'Subdomain already exists' }
   * or
   * { status: 'error', message: { subdomain: 'The subdomain field ...' }, data: { subdomain: '...' } }
   */
  private extractApiErrorMessage(res: any): string {
    const rawMsg = res?.message;
    if (typeof rawMsg === 'string' && rawMsg.trim()) {
      return rawMsg;
    }
    const nestedMsg = res?.message?.subdomain || res?.data?.subdomain;
    if (typeof nestedMsg === 'string' && nestedMsg.trim()) {
      return nestedMsg;
    }
    return this.utils.translate('Verification failed. Please try again later.');
  }
}
